import { EmptyState } from "@/components/EmptyState/EmptyState"
import { Text } from "@/elements"
import { MyJobsClosedJobPostsQueryQuery } from "@/gql/graphql"
import LoaderRow from "./LoaderRow"
import TableRow from "./TableRow"

const TableHeaderCell = ({ text, width }: { text: string; width?: number }) => {
  return (
    <th className="px-4 py-3 text-left" style={{ minWidth: `${width}px` }}>
      <Text className="text-fg-3" variant="CTASmall">
        {text}
      </Text>
    </th>
  )
}

interface Props {
  currentUserField: "client" | "creative"
  data: MyJobsClosedJobPostsQueryQuery | undefined
  loading?: boolean
}

export const ClosedJobsTable: React.FC<Props> = ({ data, loading, ...props }) => {
  const edges = data?.currentUser?.[props.currentUserField]?.jobPostings?.edges || []

  return (
    <div className="bg-white hidden overflow-x-auto sm:block">
      <table className="w-full min-w-[1120px] table-auto">
        <thead className="border-b border-bg-3">
          <tr className="bg-gray-200 text-gray-600 text-sm uppercase leading-normal">
            <TableHeaderCell text="Job" width={424} />
            {/*  <TableHeaderCell text="Hired" /> */}
            <TableHeaderCell text="Date Posted" width={151} />
            <TableHeaderCell text="Rate" width={140} />
            <TableHeaderCell text="Applicants" width={84} />
            <th className="px-6 py-3 text-center" style={{ minWidth: "190px" }}>
              <Text className="text-fg-3" variant="CTASmall">
                Quick Actions
              </Text>
            </th>
          </tr>
        </thead>

        {loading ? (
          <tbody>
            {new Array(5).fill(0).map((_, index) => (
              <LoaderRow key={index} index={index} />
            ))}
          </tbody>
        ) : (
          <></>
        )}

        {!loading && edges.length > 0 ? (
          <tbody className="text-gray-600 text-sm font-light">
            {edges.map((item, index) => (
              <TableRow key={item?.node?.id} data={item?.node} />
            ))}
          </tbody>
        ) : (
          <></>
        )}
      </table>
      {!loading && edges.length === 0 ? (
        <div className="mt-[54px] flex w-full justify-center">
          <EmptyState title="No closed jobs" description="You don't have any closed jobs." />
        </div>
      ) : (
        <></>
      )}
    </div>
  )
}
